import configureVue from "./configureVue";

export function configure() {
    configureVue();
}
